import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from '@betstarters/auth'
import { initI18n } from '@betstarters/i18n'
import i18next from 'i18next'
import App from './App'
import { api } from './api'
import { messageOf } from './lib/apiError'
import { clearLoadError, setLoadError } from './lib/loadError'
import './index.css'

// Import app-specific translations
import enApp from './i18n/locales/en/app.json'
import itApp from './i18n/locales/it/app.json'
import esApp from './i18n/locales/es/app.json'
import ptApp from './i18n/locales/pt/app.json'

// Initialize i18n with app-specific translations
initI18n({
  appResources: {
    en: { app: enApp },
    it: { app: itApp },
    es: { app: esApp },
    pt: { app: ptApp },
  },
})

// A failed READ has to be visible. Without this, every list page rendered its
// empty state instead — an authorisation error looked like an empty catalogue
// (see lib/loadError.ts). One handler covers every query in the app.
const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => setLoadError(messageOf(error, i18next.t('app:common.errors.load'))),
    onSuccess: clearLoadError,
  }),
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider config={{ api }}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
)
